export enum Kinds {
  fill = 'Fill',
  icon = 'Icon',
  line = 'Line',
  text = 'Text',
  mark = 'Mark',
}
